var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
    var marker = new Marker('entry/manage-reviews');

    new IndexView();

    new Deletism(marker);
    new Undeletism(marker);

    new Columnator();
};
